import gql from 'graphql-tag';
import {User, ArtCollection, ArtCollectionPermission} from './fragments';

export const SaveUserMutation = gql`
  mutation saveUser(
    $_id: String
    $active: Boolean!
    $name: String!
    $loginName: String
    $role: String!
    $clients: [String!]
    $employees: [String!]
  ) {
    saveUser(
      _id: $_id
      active: $active
      name: $name
      loginName: $loginName
      role: $role
      clients: $clients
      employees: $employees
    ) {
      ...User
    }
  }
  ${User}
`;

export const SaveUserMutationConfig = {
  props: ({
    mutate,
    ownProps: {
      match: {
        params: {id: _id},
      },
    },
  }) => ({
    save: user =>
      mutate({
        variables: {_id, ...user},
        updateQueries: {
          allUsers: (
            {allUsers, ...prev},
            {
              mutationResult: {
                data: {saveUser},
              },
            }
          ) =>
            _id
              ? {...prev, allUsers: allUsers.map(user => (user._id === _id ? saveUser : user))}
              : {...prev, allUsers: [saveUser, ...allUsers]},
        },
      }),
  }),
};

export const logoutMutation = gql`
  mutation logout {
    logout
  }
`;

const artCollectionsInformationQuery = 'artCollectionsInformation';

export const SaveArtCollectionMutation = gql`
  mutation saveArtCollection($input: ArtCollectionInput) {
    saveArtCollection(input: $input) {
      ...ArtCollection
    }
  }
  ${ArtCollection}
`;

export const SaveArtCollectionMutationConfig = {
  props: ({mutate}) => ({
    saveArtCollection: artCollection =>
      mutate({
        variables: {input: {...artCollection}},
        refetchQueries: [artCollectionsInformationQuery],
      }),
  }),
};

export const SaveArtCollectionPermissionMutation = gql`
  mutation saveArtCollectionPermission($input: ArtCollectionPermissionInput) {
    saveArtCollectionPermission(input: $input) {
      _id
    }
  }
`;

export const SaveArtCollectionPermissionMutationConfig = {
  props: ({mutate}) => ({
    saveArtCollectionPermission: artCollectionPermission =>
      mutate({
        variables: {input: {...artCollectionPermission}},
        refetchQueries: [artCollectionsInformationQuery],
      }),
  }),
};

export const RemoveArtCollectionPermissionMutation = gql`
  mutation removeArtCollectionPermission($_id: String!) {
    removeArtCollectionPermission(_id: $_id)
  }
`;

export const RemoveArtCollectionPermissionMutationConfig = {
  props: ({mutate}) => ({
    removeArtCollectionPermission: _id =>
      mutate({
        variables: {_id},
        refetchQueries: [artCollectionsInformationQuery],
      }),
  }),
};

export const RemoveArtCollectionMutation = gql`
  mutation removeArtCollection($_id: String!) {
    removeArtCollection(_id: $_id)
  }
`;

export const RemoveArtCollectionMutationConfig = {
  props: ({mutate}) => ({
    removeArtCollection: _id =>
      mutate({
        variables: {_id},
        refetchQueries: [artCollectionsInformationQuery],
      }),
  }),
};

export const PublishArtCollectionMutation = gql`
  mutation publishArtCollection($_id: String!) {
    publishArtCollection(_id: $_id) {
      ...ArtCollection
    }
  }
  ${ArtCollection}
`;

export const PublishArtCollectionMutationConfig = {
  props: ({mutate}) => ({
    publishArtCollection: _id =>
      mutate({
        variables: {_id},
        refetchQueries: [artCollectionsInformationQuery],
      }),
  }),
};

export const PublishArtCollectionPermissionMutation = gql`
  mutation publishArtCollectionPermission($_id: String!) {
    publishArtCollectionPermission(_id: $_id) {
      ...ArtCollectionPermission
    }
  }
  ${ArtCollectionPermission}
`;

export const PublishArtCollectionPermissionMutationConfig = {
  props: ({mutate}) => ({
    publishArtCollectionPermission: _id =>
      mutate({
        variables: {_id},
        refetchQueries: [artCollectionsInformationQuery],
      }),
  }),
};

export const SyncArtCollectionToUserMutation = gql`
  mutation syncArtCollectionToUser($_id: String!) {
    syncArtCollectionToUser(_id: $_id) {
      ...ArtCollection
    }
  }
  ${ArtCollection}
`;

export const SyncArtCollectionToUserMutationConfig = {
  props: ({mutate}) => ({
    syncArtCollectionToUser: _id =>
      mutate({
        variables: {_id},
        refetchQueries: [artCollectionsInformationQuery],
      }),
  }),
};

export const CreateCollectionFoldersMutation = gql`
  mutation createCollectionFolders {
    createCollectionFolders
  }
`;

export const CreateCollectionFoldersMutationConfig = {
  props: ({mutate}) => ({
    createCollectionFolders: () => mutate(),
  }),
};



// WEBPACK FOOTER //
// ./src/qql-shared/mutations.js